import { stripeApi } from '@ctct/infrastructure-layer';

import { ElementsCredentialsSchema } from './schemas';
import type { CreateElementsCredentialsPayload, UpdateSetupIntentParamsPayload } from './types';
import { zodService } from '../ZodService';

class StripeRepo {
  public async createElementsCredentials(payload: CreateElementsCredentialsPayload) {
    const response = await stripeApi.createElementsCredentials(this.createElementsCredentialsRequest(payload));

    return zodService.safeParse(ElementsCredentialsSchema, response);
  }

  public async updateSetupIntentParams({
    quoteId,
    countryCode,
    currencyCode,
    paymentMethodId,
    returnUrl,
    paymentMethodOptions,
  }: UpdateSetupIntentParamsPayload) {
    const response = await stripeApi.updateSetupIntentParams({
      quoteId,
      countryCode,
      currencyCode,
      paymentMethodId,
      returnUrl,
      paymentMethodOptions,
    });

    return zodService.safeParse(ElementsCredentialsSchema, response);
  }

  private createElementsCredentialsRequest({ useCase: _useCase, ...payload }: CreateElementsCredentialsPayload) {
    return payload;
  }
}

export const stripeRepo = new StripeRepo();
